module.exports = __webpack_public_path__ + "8032953d1e9b60f6229f51e31ebba1b4.png";